import "@/App.css";

function App() {
  return (
    <div className="App" data-testid="thank-you-page">
      <main className="thank-you-container">
        <div className="accent-line"></div>
        <div className="content">
          <h1 className="thank-you-title">Gracias por contactarnos</h1>
          <p className="thank-you-message">
            Hemos recibido tu consulta y nos pondremos en contacto contigo a la brevedad.
          </p>
        </div>
      </main>
    </div>
  );
}

export default App;
